var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"generic-page mt-page",class:_vm.$mq == 'sm' ? 'mx-1' : 'mx-5'},[(_vm.contentKey)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.$i18n.gt(_vm.contentKey))}},[_vm._v("\n        "+_vm._s(_vm.contentKey)+"\n    ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }